import React from 'react';

interface Props {
  src: string;
  alt: string;
}

const Picture = (props: Props) => {
  return <div className="h-12 w-12 rounded-full border-gray-500 overflow-hidden border-2">
    <img className="h-12 w-12 bg-white object-contain" src={props.src} alt={props.alt} />
  </div>
}

export default Picture;
